const TURN_HOST = process.env.REACT_APP_TURN_HOST || 'smartsar.kr';
const TURN_PORT = process.env.REACT_APP_TURN_PORT || '3478';
const TURN_USER = process.env.REACT_APP_TURN_USER || 'nemo';
const TURN_CREDENTIAL = process.env.REACT_APP_TURN_CREDENTIAL || 'RESCUE_turn7788!';

export const ICE_MEDIA_OPTIONS = {
  iceServers: [
    {
      urls: [`turn:${TURN_HOST}:${TURN_PORT}?transport=udp`, `turn:${TURN_HOST}:${TURN_PORT}?transport=tcp`],
      username: TURN_USER,
      credential: TURN_CREDENTIAL,
    },
  ],
  iceTransportPolicy: 'relay' as const,
};
